import { Button, Dialog, DialogActions, DialogContent, Tooltip } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import MergeIcon from '@mui/icons-material/Merge';
import { useState } from 'react';

const SubtitleIconLeftColumn = ({ index, rowData, updateSubIndex, mergeSub, readOnly }) => {
    const [isCommentBoxOpen, setCommentBoxOpen] = useState(false);
    const [commentText, setCommentText] = useState('');
    const [anchorIndex, setAnchorIndex] = useState(null);

    const handleCommentBoxClose = () => {
        setCommentBoxOpen(false);
    };

    return (
        <div
            id={`commentDivIcon${index}`}
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
                width: '30px',
            }}
        >
            <Tooltip title={readOnly ? 'Read-only: comments are locked' : 'Add or view comments'} placement="left">
                <ChatIcon
                    id={`commentIcon${index}`}
                    style={{
                        fontSize: '19px',
                        marginRight: '10px',
                        cursor: readOnly ? 'not-allowed' : 'pointer',
                        opacity: readOnly ? 0.5 : 1,
                        color: rowData?.note ? 'green' : null,
                    }}
                    onClick={() => {
                        if (readOnly) return;
                        setCommentBoxOpen(true);
                        setCommentText(rowData?.note);
                        setAnchorIndex(index);
                    }}
                />
            </Tooltip>

            <Dialog
                id={`commentDialog${index}`}
                BackdropProps={{
                    style: { opacity: 0.1 },
                }}
                open={isCommentBoxOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <textarea
                        id={`commentTextInput${index}`}
                        placeholder={'Enter a comment.'}
                        style={{ minWidth: '300px', minHeight: '100px' }}
                        defaultValue={commentText ?? ''}
                        onChange={(e) => setCommentText(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCommentBoxClose}>Cancel</Button>
                    <Button
                        onClick={() => {
                            updateSubIndex(rowData, { note: commentText }, anchorIndex);
                            handleCommentBoxClose();
                        }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            <Tooltip title={readOnly ? 'Read-only: merging is locked' : 'Merge with next subtitle'} placement="left">
                <MergeIcon
                    id={`mergeIcon${index}`}
                    style={{
                        fontSize: '19px',
                        marginRight: '10px',
                        cursor: readOnly ? 'not-allowed' : 'pointer',
                        opacity: readOnly ? 0.5 : 1,
                    }}
                    onClick={() => {
                        if (readOnly) return;
                        mergeSub(rowData);
                    }}
                />
            </Tooltip>
        </div>
    );
};

export default SubtitleIconLeftColumn;
